import React, { Component } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Alert } from 'reactstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { inject, observer } from 'mobx-react';
import * as Sentry from '@sentry/browser';
import ControlledInput from 'components/shared/controlled-input';
import { withCookies } from 'react-cookie';
import actions from '../../api/actions';
import RootModelStore from 'stores/root-model-store';
import _ from 'lodash';

const ConnectedLoginForm = withCookies(
  inject(
    'sessionStore',
    'routing',
  )(
    observer(
      class LoginForm extends Component {
        state = { email: '', password: '', error: '' };

        handleChange(e) {
          const name = e.target.name;
          const val = e.target.value;
          this.setState({ [name]: val });
        }

        handleSubmit(e) {
          e.preventDefault();
          const { email, password } = this.state;
          const credentials = { email, password };
          actions
            .login(credentials)
            .then(r => {
              _.forEach(RootModelStore.stores, store => store.reset());
              return this.props.sessionStore.login(r, this.props.cookies);
            })
            .catch(error => {
              console.error('encountered error signing in', error);
              if (error.response) {
                // The server responded with a non-2xx.
                if (error.response.data && error.response.data.error) {
                  this.setState({ error: error.response.data.error });
                } else {
                  this.setState({
                    error:
                      'We encountered an error trying to log in. Make user your email and password are correct.',
                  });
                }
              } else if (error.request) {
                // No response received.
                this.setState({
                  error:
                    "We weren't able to communicate with our server for some reason.",
                });
              } else {
                Sentry.withScope(scope => {
                  scope.setExtra('formData', credentials);
                  Sentry.captureException(error);
                });
                this.setState({ error: 'We encountered an unknown error.' });
              }
            });
        }

        createInputs = () => (
          <React.Fragment>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <ControlledInput
                name="email"
                type="email"
                value={this.state.email}
                onChange={this.handleChange.bind(this)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <ControlledInput
                name="password"
                type="password"
                value={this.state.password}
                onChange={this.handleChange.bind(this)}
              />
            </div>
          </React.Fragment>
        );

        dismissError() {
          this.setState({ ...this.state, error: '' });
        }

        render() {
          const { error } = this.state;
          return (
            <Row>
              <Col md={6} className="offset-md-3">
                <p>&nbsp;</p>
                <Card className="register-panel">
                  <CardHeader>
                    <h2 className="m-0">Sign In</h2>
                  </CardHeader>
                  <CardBody>
                    <form onSubmit={this.handleSubmit.bind(this)}>
                      <Alert
                        color="danger"
                        isOpen={!!error}
                        toggle={this.dismissError.bind(this)}
                      >
                        {error}
                      </Alert>
                      {this.createInputs()}
                      <p>
                        <LinkContainer to="/password">
                          <button type="button" className="blue link p-0">
                            Forgot Password?
                          </button>
                        </LinkContainer>
                      </p>
                      <input
                        value="Sign In"
                        className="btn btn-primary"
                        type="submit"
                      />
                    </form>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          );
        }
      },
    ),
  ),
);

export default ConnectedLoginForm;
